import { Document } from "models/schemas";
import { StagedFile } from "./definitions";

/**
 * Returns the document(s) representing all versions for a file.
 * With Document, versions are embedded — returns the document itself.
 */
export const getAllVersionsForFile = (stagedFile: StagedFile): Document[] => {
  if (!stagedFile.originalDocument) return [];
  return [stagedFile.originalDocument];
};

/**
 * Filters staged files for display by removing deleted files and older versions
 */
export const filterDisplayFiles = (stagedFiles: StagedFile[]): StagedFile[] => {
  return stagedFiles.filter((f) => {
    if (f.toDelete) return false;
    if (f.originalDocument && f.isLatest === false) return false;
    return true;
  });
};

/**
 * Converts a Document to StagedFile format
 */
export const createStagedFileFromDocument = (
  document: Document,
  additionalProps?: Partial<StagedFile>,
): StagedFile => {
  const versionCount = (document.versions?.length ?? 0) + 1;

  return {
    id: document.documentId,
    fileName: document.fileName,
    documentType: document.documentType,
    isNew: false,
    originalDocument: document,
    isLatest: true,
    versionNumber: versionCount,
    totalVersions: versionCount,
    ...additionalProps,
  };
};

/**
 * Handles cascade deletion of versioned files.
 */
export const cascadeDeleteVersionedFiles = (
  docsToDelete: StagedFile[],
  stagedFiles: StagedFile[],
): StagedFile[] => {
  const idsToDelete = new Set(docsToDelete.map((doc) => doc.id));

  return stagedFiles.map((f) =>
    idsToDelete.has(f.id) ? { ...f, toDelete: true } : f,
  );
};
